module.exports = __webpack_public_path__ + "img/introduce.e2a59a04.png";